import { render, staticRenderFns } from "./PowerBIReportDisplay.vue?vue&type=template&id=48706c84&"
import script from "./PowerBIReportDisplay.vue?vue&type=script&lang=js&"
export * from "./PowerBIReportDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports